export class SearchCondition {
  event_code: string = ""
  name: string = ""
  page: number = 1
  row_count: number =  100
}

export class Event {
  id: number
  event_code: string
  name: string
  full_count: number
  is_checked: boolean = false

  constructor(x: any){
    this.id = x.id;
    this.event_code = x.event_code;
    this.name = x.name;
    this.full_count = x.full_count;
  }
}